
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Auth from "@/lib/common/auth";
import * as echarts from "echarts";
import UpgradeUser from "@/components/UpgradeUser.vue";
import PieOption from "./ts/templatePie";
import PositionList, {
  Industry,
  Position,
  PositionIndustryList,
  Template
} from "@/lib/position/position";
import { Dimension } from "@/lib/dimension/dimension";
import MsgRequest from "@/lib/model/message/MsgRequest";
import Loading from "@/components/loading.vue";
import QuestionCardV2 from "./components/question-card-v2.vue";
import { backgroundSize } from "html2canvas/dist/types/css/property-descriptors/background-size";
import vuexStore from "@/store/vuex-store";
// import { ExamV2Custom, Template } from "@/lib/model/exambuilder/exam-v2";

@Component({ components: { Loading, QuestionCardV2, UpgradeUser } })
export default class TemplateDetail extends Vue {
  @Prop({}) detailTemp!: Template;
  @Prop() index!: number;
  @Prop() disabled!: string;
  @Prop({ default: false }) isFirstDialog!: boolean; //是否是第一层弹窗

  loading = false;
  showDetail = false;
  title = "新建短信通知模板";
  height = "";
  isVipUser = false;
  // userVip = true;
  innerVisible = false;

  loadingStart = 0; //加载开始时间
  refreshMe = true;

  colorList = [
    "#4CDE99",
    "#FDC151",
    "#33DFE4",
    "#8851FD",
    "#33B1FF",
    "#FF9245",
    "#FD5151",
    "#BDFD51",
    "#516AFD",
    "#B999D4",
    "#51FD84",
    "#FD51B8",
    "#FDFB51",
    "#51FDC5",
    "#E551FD",
    "#FF7717",
    "#009EFF",
    "#A87FC9",
    "#FDB225",
    "#00D7DD",
    "#00D16E"
  ];

  async created() {
    //
    // await this.getCompanyPower();
  }

  mounted() {
    this.sss(this.detailTemp);
  }
  //overflow 切换后复位
  refresh() {
    this.refreshMe = false;
    this.$nextTick(() => {
      this.refreshMe = true;
    });
  }

  @Watch("detailTemp", { deep: true })
  async sss(n: Template) {
    this.refresh();
    this.isVipUser = n.vipLevel === 10 && vuexStore.companyPower.vipLevel < 10;
    this.$nextTick(() => {
      this.getHeight();
      this.setEcharts(n);
    });
  }

  setEcharts(detailTemp: Template = this.detailTemp) {
    const container = this.$refs.ec;
    const chart = echarts.init(container as HTMLElement);
    const data = detailTemp.dimensionList.map(el => ({
      name: el.dimensionName,
      value: el.questionCount
    }));
    chart.setOption(PieOption(data, this.colorList));
  }

  getHeight() {
    const rightHeight = (this.$refs.right as HTMLElement).offsetHeight;
    const descHeight = (this.$refs.description as HTMLElement).offsetHeight;
    const height = rightHeight - descHeight - 102 - 64 + 20;
    this.height = height + "px";
  }

  watchOther(differ: number) {
    this.$emit("watch", this.index + differ);
  }

  //保证最少300ms loading
  endLoading() {
    const now = new Date().getTime();
    const time = now - this.loadingStart;
    if (time < 300) {
      setTimeout(() => {
        this.loading = false;
      }, 300 - time);
    } else {
      this.loading = false;
    }
  }

  // 使用模板
  useTemplate(temp: Template) {
    this.$emit("useTemplate", temp);
  }

  ok() {
    //
  }

  //关闭
  close() {
    this.$emit("cancel");
  }
  back() {
    this.$emit("back");
  }
}
